<template>
  <v-row justify="center" class="mt-7">
    <v-col cols="12" lg="10" md="10" sm="12" xs="12">
      <v-card class="rounded-lg mt-2" elevation="2">
        <v-row justify="center">
          <v-col cols="12" lg="11" md="11" sm="12" xs="12">
            <div class="speaker-title-row">
              <v-card-title>
                <div class="subject-title">{{ $t('SPEAKERS.title') }}</div>
              </v-card-title>
              <v-btn
                id="speakers-create-button"
                dark
                color="blue"
                @click="$router.push('/dashboard/speaker/new')"
              >
                {{ $t('SPEAKERS.create_button') }}
                <v-icon dark class="ml-2">{{ icon.mdiPlus }}</v-icon>
              </v-btn>
            </div>

            <v-data-table 
              :headers="headers.map(h => ({ ...h, text: $t('SPEAKERS.headers.' + h.text) }))"
              :items="[...speakers].sort((s1, s2) => s1.name.toLowerCase() < s2.name.toLowerCase() ? -1 : 1)"
            >
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn
                  icon
                  @click="editSpeaker(item)"
                >
                  <v-icon>{{ icon.mdiPencil }}</v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="deleteSpeaker(item)"
                >
                  <v-icon color="red">{{ icon.mdiDelete }}</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
      <v-dialog 
        v-model="dialogSpeaker"
        transition="dialog-bottom-transition"
        max-width="600"
        persistent
      >
        <SpeakerForm @close="dialogSpeaker = false" />
      </v-dialog>
    </v-col>
  </v-row>
</template>
<script>
import { mdiDelete, mdiPencil, mdiPlus } from "@mdi/js";
import SpeakerForm from '@/components/atoms/SpeakerForm.vue';
import { mapGetters } from 'vuex'

export default {
  name: "SpeakerTable",
  components: {
    SpeakerForm,
  },
  data: () => ({
    icon: {
      mdiDelete,
      mdiPencil,
      mdiPlus
    },
    headers: [
      { text: "name", value: "name" },
      { text: "email", value: "email" },
      { text: "manage", value: "actions", sortable: false }
    ],
    dialogSpeaker: false,
  }),
  computed: {
    ...mapGetters(['speakers'])
  },
  async created() {
    await this.$store.dispatch("getSpeakers");
  },
  methods: {
    editSpeaker(item) {
      this.$router.push(`/dashboard/speaker/${item.id}/edit`);
    },
    async deleteSpeaker(item) {
      if(confirm("Are you sure you want to delete it? This action cannot be undone!")) {
        try {
          await this.$store.dispatch("deleteSpeaker", item.id);

          if (item.image) {
            this.$store.dispatch("deleteSpeakerImage", item.id);
          }
          
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Success on delete the Speaker",
            color: "success",
          });

          this.$store.dispatch("getSpeakers");
        } catch(e) {
          console.error('Error on delete the speaker');
          this.$store.dispatch("setSnackbar", {
            show: true,
            text: "Oops... Error on delete the Speaker",
            color: "error",
          });
        }
      }
    }
  },
}
</script>

<style scoped>
.subject-title {
  font-size: 120%;
  font-weight: 700;
  color: #4f4f4f;
  font-family: "Open Sans", sans-serif;
}

.speaker-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.speaker-title-row .v-btn {
  margin-right: 16px;
}

@media (max-width: 390px) {
  .speaker-title-row {
    flex-direction: column;
    margin-bottom: 24px;
  }
  
  .speaker-title-row .v-btn {
    margin-right: 0;
  }
}
</style>
